module.exports = __webpack_public_path__ + "img/banner-web-1.c014e193.jpg";